import Button from '../../general/Button'

const ListToogleAllButtons = ({
    setAllOpen
}) => (
    <div className='list-toogle-all-buttons'>
        <Button
            transId="button_open_all"
            className="cursor-pointer"
            hideText={false}
            onClick={() => setAllOpen(true)}
        />

        <Button
            transId="button_close_all"
            className="cursor-pointer"
            hideText={false}
            onClick={() => setAllOpen(false)}
        />
    </div>

)

export default ListToogleAllButtons